// export default () => ({
// })

export default () => ({
    vehicles: [],
    vehiclesSelectable: [],
    vehiclesPaginatedData: null,
    vehicle: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})